/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Card } from 'primereact/card'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Paginator } from 'primereact/paginator'
import { Dialog } from 'primereact/dialog'
import { ProgressSpinner } from 'primereact/progressspinner'

export default function AuditComponent({ auditList, getAuditsByPage, totalRecords, getAudit, activeData, auditLog }) {
  const [auditData, setAuditData] = useState([])
  const [first, setFirst] = useState(0)
  const [page, setPage] = useState(0)
  const pageSize = 10
  const [isLoading, setIsLoading] = useState(false)
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [oldContent, setOldContent] = useState([])
  const [newContent, setnewContent] = useState([])
  const search = ''

  useEffect(() => {
    getAuditsByPage(page, pageSize, search)
  }, [activeData, getAuditsByPage, page])
  useEffect(() => {
    const auditArray = []
    for (let i = 0; i < auditList.length; i++) {
      const audit = auditList[i]
      const content = JSON.parse(audit.content)
      const createdAt = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(audit.modifiedDate)
      auditArray.push({ 'datetime': createdAt, 'entityname': audit.name, 'record_name': content.name, 'created_by': audit.modifiedUser, 'action': audit.action, 'audit_id': audit.auditId })
    }
    setAuditData(auditArray)
  }, [auditList])

  const timeRead = (timeStamp) => {
    return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(timeStamp)
  }
  useEffect(() => {
    let getLog = auditLog.auditInfo
    if (getLog) {
      getLog = getLog.data
      const logJson = getLog[0]
      const oldLogJson = getLog[1]
      setnewContent(logJson)
      setOldContent(oldLogJson)
    }
  }, [auditLog])

  const logDiff = diff(newContent, oldContent)
  function diff(obj1, obj2) {
    const result = {}
    if (Object.is(obj1, obj2)) {
      return undefined
    }
    if (!obj2 || typeof obj2 !== 'object') {
      return obj2
    }
    Object.keys(obj1 || {}).concat(Object.keys(obj2 || {})).forEach(key => {
      if (obj2[key] !== obj1[key] && !Object.is(obj1[key], obj2[key])) {
        result[key] = obj2[key]
      }
      if (typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
        const value = diff(obj1[key], obj2[key])
        if (value !== undefined) {
          result[key] = value
        }
      }
    })
    return result
  }

  const textModifedClass = (field) => {
    return logDiff.hasOwnProperty(field) ? 'text-hightlight' : ''
  }


  const logoTemplate = (rowData) => {
    return rowData.logoPath && rowData.logoPath.trim().length > 0 && (rowData.encodedImageString ?
      <img alt="Company Logo" src={`data:image/jpeg;base64,${rowData.encodedImageString}`} style={{ width: '20px' }}></img>
      :
      <img alt="Company Logo" src={`${rowData.logoPath}`} style={{ width: '20px' }}></img>
    )
  }

  function Company(log) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('name')} >
            <label className="inputHolder--label">Name</label>
            {log.companyLog.name || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('ticker')} >
            <label className="inputHolder--label">Ticker </label>
            {log.companyLog.ticker || '--'}
          </span>
        </div>

        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('logoPath')} >
            <label className="inputHolder--label">Logo</label>
            {logoTemplate(log.companyLog) || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('sectorName')} >
            <label className="inputHolder--label">Sector</label>
            <span>{log.companyLog.sectorName || '--'}</span>
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('industryName')} >
            <label className="inputHolder--label">Industry</label>
            {log.companyLog.industryName || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('exchangeName')} >
            <label className="inputHolder--label">Exchange</label>
            <span>{log.companyLog.exchangeName || '--'}</span>
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('marketCapitalization')} >
            <label className="inputHolder--label">Market Capitalization(USD)</label>
            {log.companyLog.marketCapitalization || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('exchangeCountry')} >
            <label className="inputHolder--label">Exchange Country</label>
            {log.companyLog.exchangeCountry || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('earningsYeild')} >
            <label className="inputHolder--label">Earnings Yield</label>
            {log.companyLog.earningsYeild || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('barriers')} >
            <label className="inputHolder--label">Barriers</label>
            {log.companyLog.barriers || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('financialStrength')} >
            <label className="inputHolder--label">Financial Strength</label>
            {log.companyLog.financialStrength || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('momentum')} >
            <label className="inputHolder--label">Momentum</label>
            {log.companyLog.momentum || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('underValued')} >
            <label className="inputHolder--label">Under Valued</label>
            {log.companyLog.underValued || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('growthType')} >
            <label className="inputHolder--label">Growth Type</label>
            {log.companyLog.growthType || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('topNewsBuy')} >
            <label className="inputHolder--label">Top New Buys</label>
            {log.companyLog.topNewsBuy || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('dividendLeader')} >
            <label className="inputHolder--label">Dividend Leader</label>
            {log.companyLog.dividendLeader || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('sociallyResponsible')} >
            <label className="inputHolder--label">Socially Responsible</label>
            {log.companyLog.sociallyResponsible || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('watchlist')} >
            <label className="inputHolder--label">Watch List</label>
            {log.companyLog.watchlist || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('intersection')} >
            <label className="inputHolder--label">Intersection</label>
            {log.companyLog.intersection || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedOn')} >
            <label className="inputHolder--label">Updated on</label>
            {(log.companyLog.updatedOn && timeRead(log.companyLog.updatedOn)) || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedUser')} >
            <label className="inputHolder--label">Updated By</label>
            {log.companyLog.updatedUser || '--'}
          </span>
        </div>
      </div>

    )
  }

  function Industry(log) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('name')} >
            <label className="inputHolder--label">Name</label>
            {log.industryLog.name || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('sequence')} >
            <label className="inputHolder--label">Sequence</label>
            {log.industryLog.sequence || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('headWind')} >
            <label className="inputHolder--label">Head Wind</label>
            {log.industryLog.headWind || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('tailWind')} >
            <label className="inputHolder--label">Tail Wind</label>
            {log.industryLog.tailWind || '--'}
          </span>
        </div>
        <div className="p-col-12" >
          <span className={'inputHolder ' + textModifedClass('armyGolden')}>
            <label className="inputHolder--label">Army Golden</label>
            {log.industryLog.armyGolden || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('armyBlue')} >
            <label className="inputHolder--label">Army Blue</label>
            {log.industryLog.armyBlue || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('active')} >
            <label className="inputHolder--label">Status</label>
            {log.industryLog.active ? (
              <span>Active</span>
            ) : (
                <span>Inactive</span>
              )
            }
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedOn')} >
            <label className="inputHolder--label">Updated on</label>
            {(log.industryLog.updatedOn && timeRead(log.industryLog.updatedOn)) || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedUser')} >
            <label className="inputHolder--label">Updated By</label>
            {log.industryLog.updatedUser || '--'}
          </span>
        </div>
      </div>

    )
  }

  function Sector(log) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('name')} >
            <label className="inputHolder--label">Sector Name</label>
            {log.sectorLog.name || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('sequence')} >
            <label className="inputHolder--label">Sequence</label>
            {log.sectorLog.sequence || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('year')} >
            <label className="inputHolder--label">Year</label>
            {log.sectorLog.year || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('active')} >
            <label className="inputHolder--label">Status</label>
            {log.sectorLog.active ? (
              <span>Active</span>
            ) : (
                <span>Inactive</span>
              )
            }
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedOn')} >
            <label className="inputHolder--label">Updated on</label>
            {(log.sectorLog.updatedOn && timeRead(log.sectorLog.updatedOn)) || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedUser')} >
            <label className="inputHolder--label">Updated By</label>
            {log.sectorLog.updatedUser || '--'}
          </span>
        </div>
      </div>

    )
  }

  function Exchange(log) {
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('name')} >
            <label className="inputHolder--label">Exchange Name</label>
            {log.exchangeLog.name || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedOn')} >
            <label className="inputHolder--label">Updated on</label>
            {(log.exchangeLog.updatedOn && timeRead(log.exchangeLog.updatedOn)) || '--'}
          </span>
        </div>
        <div className="p-col-12">
          <span className={'inputHolder ' + textModifedClass('updatedUser')} >
            <label className="inputHolder--label">Updated By</label>
            {log.exchangeLog.updatedUser || '--'}
          </span>
        </div>
      </div>
    )
  }

  const showAuditById = (e, rowData) => {
    setIsLoading(true)
    setIsDialogVisible(true)
    getAudit(rowData.audit_id)
    setIsLoading(false)
  }

  const actionTemplate = (rowData) => {
    if (rowData.action === 'UPDATE' && rowData.entityname !== 'SubBrand') {
      return <div className="flexCenterCenter">
        {(rowData.active) ? <i className="pi pi-eye-slash m-r-10 pointer" title="De-Activate" onClick={(event) => showAuditById(event, rowData)}></i> : <i className="pi pi-eye m-r-10 pointer" title="Activate" onClick={(event) => showAuditById(event, rowData)}></i>}
      </div>
    } else {
      return <></>
    }

  }


  const onPageChange = (event) => {
    setFirst(event.first)
    setPage(event.page)
    getAuditsByPage(event.page, pageSize, search)
  }

  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <DataTable className="manageTableHeight" emptyMessage='No records found' value={auditData} totalRecords={totalRecords} rows={pageSize} scrollable={true} responsive={true}>
            <Column key={'datetime'} field={'datetime'} header={'Event Time Stamp'} style={{ textAlign: 'left', width: '15em' }} />
            <Column key={'entityname'} field={'entityname'} header={'Table Name'} style={{ textAlign: 'left', width: '12em' }} />
            <Column key={'record_name'} field={'record_name'} header={'Record Name'} className="customnowrap" style={{ textAlign: 'left', width: '20em' }} />
            <Column key={'created_by'} field={'created_by'} header={'Performed By'} style={{ textAlign: 'left', width: '16em' }} />
            <Column key={'action'} field={'action'} header={'Action Performed'} style={{ textAlign: 'center', width: '10em' }} />
            <Column key={'view'} body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} header={'Action'} />
          </DataTable>
          <div className="p-col-12 p-0">
            <Paginator first={first} rows={pageSize} scrollable={true} responsive={true} totalRecords={totalRecords} onPageChange={onPageChange}></Paginator>
          </div>
        </Card>
      </div>
      <Dialog className="auditCon" header={'View Audit History (' + newContent.entityName + ')'} style={{ width: '50vw' }} modal={true} visible={isDialogVisible} onHide={() => setIsDialogVisible(false)}>
        <div className="center-pg">
          {isLoading &&
            <div className="center-pg">
              <ProgressSpinner />
            </div>
          }
        </div>
        <div className="p-grid audit-view">
          <div className="p-col-6">
            <b>Before Modification</b>
          </div>
          <div className="p-col-6">
            <b>After Modification</b>
          </div>
          {(newContent.entityName === 'Company') &&
            <>
              <div className="p-col-6">
                <Company companyLog={oldContent} />
              </div>
              <div className="p-col-6">
                <Company companyLog={newContent} />
              </div>
            </>
          }
          {(newContent.entityName === 'Industry') &&
            <>
              <div className="p-col-6">
                <Industry industryLog={oldContent} />
              </div>
              <div className="p-col-6">
                <Industry industryLog={newContent} />
              </div>
            </>
          }
          {(newContent.entityName === 'Sector') &&
            <>
              <div className="p-col-6">
                <Sector sectorLog={oldContent} />
              </div>
              <div className="p-col-6">
                <Sector sectorLog={newContent} />
              </div>
            </>
          }
          {(newContent.entityName === 'Exchange') &&
            <>
              <div className="p-col-6">
                <Exchange exchangeLog={oldContent} />
              </div>
              <div className="p-col-6">
                <Exchange exchangeLog={newContent} />
              </div>
            </>
          }
        </div>
      </Dialog>
    </div>
  )
}
AuditComponent.propTypes = {
  auditList: PropTypes.array,
  getAuditsByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  getAudit: PropTypes.func,
  auditLog: PropTypes.object,
}
